module.exports = __webpack_public_path__ + "img/iconoMapa.dfce70d8.png";